<lib-gung-calendar-view
  [calendarItems]="calendarItemsList"
  [enableCreateItem]="false"
  (createItemEvent)="createProductionOrder($event)"
  [enableChangeDate]="true"
  (changeDateEvent)="changeProductionOrderDate($event)"
  [enableDragDropChangeDate]="true"
  (dragDropEvent)="changeProductionOrderDate($event)"
></lib-gung-calendar-view>